<div class="projectable-form-wrapper">
    <div class="header">
        <div class="title">Manage <span>{{pageTitle}}</span></div>
        <div class="line"></div>
        <div class="tabs">
          <div class="tab" routerLink="/settings">Manage Settings</div>
          <div class="tab selected">Manage <span>{{pageTitle}}</span></div>
        </div>
        <div class="constrained">
            @if (passwordChangeDisabled) {
                <div class="password-change-message">{{passwordChangeMessage}}</div>
            } @else {
                <div class="grid split">
                    <div>
                        <label>Current Password</label>
                        <input [(ngModel)]="currentPassword" type="password" autocomplete="new-password"/>
                    </div>
                    <div></div>
                    <div>
                        <label>New Password</label>
                        <input [(ngModel)]="newPassword" type="password" autocomplete="new-password"/>
                    </div>
                    <div>
                        <label>Confirm Password</label>
                        <input [(ngModel)]="confirmPassword" type="password" autocomplete="new-password"/>
                    </div>
                    <div></div>
                    <div>
                        <div class="button" (click)="resetPassword()">Save</div>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
